import { appInsights } from "./appInsights";
import { APP_KPI_NAME } from "./utils";

export interface TransactionContext {
  module: string;
  screen?: string;
  action: string;
  role?: string;
  entityType?: string;
  entityId?: string;
}

export async function runTransaction<T>(
  context: TransactionContext,
  fn: (transactionId: string) => Promise<T>,
): Promise<T> {
  const startedAt = performance.now();
  const transactionId = crypto.randomUUID();

  try {
    const result = await fn(transactionId);
    const durationMs = performance.now() - startedAt;

    appInsights.trackMetric({
      name: APP_KPI_NAME.PCS_TRANSACTION,
      average: durationMs,
      sampleCount: 1,
      properties: {
        module: context.module,
        screen: context.screen ?? "",
        action: context.action,
        role: context.role ?? "",
        entityType: context.entityType ?? "",
        entityId: context.entityId ?? "",
        transactionId,
        success: "true",
      } as never,
    });

    appInsights.trackEvent({
      name: `${APP_KPI_NAME.PCS_TRANSACTION}_completed`,
      properties: {
        module: context.module,
        screen: context.screen ?? "",
        action: context.action,
        role: context.role ?? "",
        entityType: context.entityType ?? "",
        entityId: context.entityId ?? "",
        transactionId,
        durationMs,
        success: true,
      },
    });
    return result;
  } catch (error: any) {
    const durationMs = performance.now() - startedAt;
    appInsights.trackMetric({
      name: APP_KPI_NAME.PCS_TRANSACTION,
      average: durationMs,
      sampleCount: 1,
      properties: {
        module: context.module,
        screen: context.screen ?? "",
        action: context.action,
        role: context.role ?? "",
        entityType: context.entityType ?? "",
        entityId: context.entityId ?? "",
        transactionId,
        success: "false",
      } as never,
    });

    appInsights.trackEvent({
      name: `${APP_KPI_NAME.PCS_TRANSACTION}_failed`,
      properties: {
        module: context.module,
        screen: context.screen ?? "",
        action: context.action,
        role: context.role ?? "",
        entityType: context.entityType ?? "",
        entityId: context.entityId ?? "",
        transactionId,
        durationMs,
        success: false,
        errorMessage: error?.message ?? "Unknown error",
      },
    });

    appInsights.trackException({
      exception: error,
      properties: {
        module: context.module,
        screen: context.screen ?? "",
        action: context.action,
        role: context.role ?? "",
        entityType: context.entityType ?? "",
        entityId: context.entityId ?? "",
        transactionId,
        telemetryType: APP_KPI_NAME.PCS_TRANSACTION,
      },
    });

    throw error;
  }
}
